import React from 'react';
import {ChannelLogo} from '../../channels/ChannelLogo';

/**
 * El logo de una plataforma en su baldosa, para las tres superficies de la pantalla (la fila, la
 * tarjeta de descubrimiento y el menú «Conectar una plataforma»).
 *
 * `useOld={false}` y `renderVeryColoredVersion`, como en la 2.1 del Media Plan: sin ellos LinkedIn
 * sale gris (su versión «apagada») y Google con el logo viejo de AdWords. Los márgenes en 0 porque
 * `ChannelLogo` trae los suyos por canal y en una fila compacta desalinean un logo de otro.
 */
export function PlatformLogo({channel, size = 22, className = ''}) {
    return (
        <span className={`apl-logo${className ? ` ${className}` : ''}`} aria-hidden="true">
            <ChannelLogo channel={channel} useOld={false} renderVeryColoredVersion
                         hspace={0} vspace={0} marginLeft={0} padding={0} width={size} height={size}/>
        </span>
    );
}

export default PlatformLogo;
